import { useRootStore } from "store";
import { captureEvent } from "components/posthog/customEventCapture";
import { InventoryItem, StateName } from "models/inventory/inventory";

import "./InventoryList.scss";

type Props = {
  onInventoryCreatePdf: (
    inventoryId: number,
  ) => void;
  onInventoryOpen: (
    inventoryId: number,
    e: React.MouseEvent<HTMLAnchorElement, MouseEvent>
  ) => void;
  onInventorySetOngoing?: (inventoryId: number) => void;
  isInternalUser?: boolean;
};

export default function InventoryList({
  onInventoryCreatePdf,
  onInventoryOpen,
  onInventorySetOngoing,
  isInternalUser
}: Props) {
  const { inventories, statesEnglishToSwedish } = useRootStore(
    (state) => state.inventory
  );

  const toRow = (inventory: InventoryItem) => (
    <div className="inventoryWrapper-row" key={inventory.id}>
      <a className="inventoryWrapper-link" onClick={(e) => onInventoryOpen(inventory.id, e)}>
        {inventory.per_date} | Status:{" "}
        {statesEnglishToSwedish[inventory.state_name as StateName]} | Senast
        ändrad: {new Date(inventory.last_changed).toLocaleString("sv-SE")}
      </a>
      {isInternalUser && (
        <button
          className="secondaryButton mr-4 inventoryWrapper-button"
          disabled={inventory.state_name === "ongoing"}
          value={inventory.id}
          onClick={(e) => {
            if (onInventorySetOngoing) {
              onInventorySetOngoing(inventory.id);
              captureEvent("Ändra till pågående");
            }
          }}
        >
          Ändra till pågående
        </button>
      )}
      <button
        className="secondaryButton inventoryWrapper-button"
        value={inventory.id}
        onClick={(e) => {
          onInventoryCreatePdf(inventory.id);
          captureEvent("Ladda ned PDF");
        }}
      >
        Ladda ned PDF
      </button>
    </div>
  );

  const title = isInternalUser
    ? "Kundens inventeringar"
    : "Välj inventeringsformulär avseende räkenskapsår";

  return (
    <div className="inventoryWrapper">
      <h3>{title}</h3>
      {inventories.length > 0 ? (
        inventories
          .sort((a, b) => b.per_date.localeCompare(a.per_date))
          .map(toRow)
      ) : (
        <p>Det finns inga inventeringar.</p>
      )}
    </div>
  );
}
